if (!customElements.get('pickup-availability')) {
  customElements.define('pickup-availability', class PickupAvailability extends HTMLElement {
    connectedCallback() {
      this.onClick ||= async (event) => {
        if (!event.target.closest('button')) return;
        event.preventDefault();
        const drawer = document.getElementById('Pickup-Availability');
        const variantId = this.dataset.variantId;
        if (!drawer || !variantId) return;
        if (drawer.dataset.variantId !== variantId) await this.fetchAvailability(variantId, true);
        if (!this.isConnected || this.dataset.variantId !== variantId || drawer.dataset.variantId !== variantId) return;
        drawer.classList.toggle('active');
        document.body.classList.toggle('open-cc');
      };
      this.addEventListener('click', this.onClick);
    }
    disconnectedCallback() {
      this.requestController?.abort();
      this.removeEventListener('click', this.onClick);
    }
    clearAvailability() {
      this.requestController?.abort();
      this.requestController = null;
      this.removeAttribute('available');
      this.innerHTML = '';
      delete this.dataset.variantId;
    }
    async fetchAvailability(variantId, force = false) {
      if (!force && this.dataset.variantId === String(variantId)) return;
      this.clearAvailability();
      this.dataset.variantId = variantId;
      const controller = new AbortController();
      this.requestController = controller;
      const root = new URL(this.dataset.rootUrl || '/', window.location.origin);
      if (!root.pathname.endsWith('/')) root.pathname += '/';
      const url = new URL('variants/' + variantId + '/', root);
      url.searchParams.set('section_id', 'pickup-availability');
      try {
        const response = await fetch(url, { signal: controller.signal });
        if (!response.ok) throw new Error('Unable to update pickup availability');
        const markup = await response.text();
        if (controller !== this.requestController || !this.isConnected) return;
        const html = new DOMParser().parseFromString(markup, 'text/html');
        const preview = html.querySelector('.pickup-availability-information');
        if (!preview) return;
        this.innerHTML = preview.innerHTML;
        this.setAttribute('available', '');
        const drawer = document.getElementById('Pickup-Availability');
        const source = html.querySelector('.side-availability');
        if (drawer && source) {
          drawer.innerHTML = source.innerHTML;
          drawer.dataset.variantId = String(variantId);
        }
      } catch (error) {
        if (error.name !== 'AbortError' && controller === this.requestController) delete this.dataset.variantId;
      }
    }
  });
}
